import React from 'react';
import s from './s.module.less';
import ProviderTable from './components/ProviderTable';
import { PermissionModuleKeys } from 'constants/access';
import AccessDenied from 'components/AccessDenied';
import AccessStore from 'store/Access/permission';

const TextVisitProviderPage = () => {
    const [getAccessStore] = AccessStore.useStore();
    const access = getAccessStore('data');

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                {access?.[PermissionModuleKeys.KLARITY_ASSESSMENT] ? (
                    <div>
                        <h3 className={s.subtitle}>Providers</h3>
                        <ProviderTable />
                    </div>
                ) : (
                    <AccessDenied />
                )}
            </div>
        </div>
    );
};

export default TextVisitProviderPage;
